var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 15.384C24.1667 15.7689 24.1667 16.7311 23.5 17.116L13 23.1782C12.3333 23.5631 11.5 23.082 11.5 22.3122L11.5 10.1878C11.5 9.41802 12.3333 8.9369 13 9.3218L23.5 15.384Z",
    fill: "#121314"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 32.25C24.8366 32.25 32 25.0866 32 16.25C32 7.41344 24.8366 0.25 16 0.25C7.16344 0.25 0 7.41344 0 16.25C0 25.0866 7.16344 32.25 16 32.25ZM16 28.5577C22.7974 28.5577 28.3077 23.0474 28.3077 16.25C28.3077 9.45265 22.7974 3.94231 16 3.94231C9.20266 3.94231 3.69232 9.45265 3.69232 16.25C3.69232 23.0474 9.20266 28.5577 16 28.5577Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/play-button.1b2941d14f54ef07a4756f66879a4158.svg";
export { ForwardRef as ReactComponent };